import { render, staticRenderFns } from "./TraineeStatistics.vue?vue&type=template&id=76fe6738"
import script from "./TraineeStatistics.vue?vue&type=script&lang=js"
export * from "./TraineeStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports